import { ToolBarCategory } from '../models/category-tool-bar.model';

// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export class CategoryToolBarTransformer {
    public static TransformCategoryToToolbarCategory(category: any): ToolBarCategory {
        const toolBarCategory: ToolBarCategory = {
            currentCategory: category?.currentCategory || category,
            categories: category?.categories || null,
            subCategories: category?.subCategories || null,
        };

        return toolBarCategory;
    }
}
